import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  COLOR_FULFILMENT_RATE,
  DRIVER_APP_FULFILMENT_FOOTNOTES,
  DRIVER_APP_FULFILMENT_INFO,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'

import { DriverAppFulfilmentCards } from './DriverAppFulfilmentCards'
import { DriverAppFulfilmentFilterCriteria } from './DriverAppFulfilmentFilterCriteria'
import { DriverAppFulfilmentFiltersForm } from './DriverAppFulfilmentFilters'

export const DriverAppFulfilment = () => (
  <DriverAppFulfilmentFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box sx={{ maxWidth: 480, flexShrink: 0, minWidth: { lg: 380 } }}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
              Driver App vs CX Fulfilment
            </Typography>
            <Tooltip title={DRIVER_APP_FULFILMENT_INFO}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            Understand how often jobs posted to the Driver App are fulfilled through our network
            versus via the open market (CX).
          </Typography>
        </Box>

        <DriverAppFulfilmentFiltersForm />
      </Stack>

      <DriverAppFulfilmentCards />

      <Box
        sx={{
          mt: 3,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(COLOR_FULFILMENT_RATE, 0.04),
          border: 1,
          borderColor: alpha(COLOR_FULFILMENT_RATE, 0.2),
        }}>
        <Stack direction='row' spacing={1.25} alignItems='flex-start'>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: COLOR_FULFILMENT_RATE, mt: 0.25 }} />
          <Box>
            {DRIVER_APP_FULFILMENT_FOOTNOTES.map((line) => (
              <Typography
                key={line}
                variant='caption'
                color='text.secondary'
                display='block'
                sx={{ lineHeight: 1.7 }}>
                {line}
              </Typography>
            ))}
          </Box>
        </Stack>
      </Box>
    </Box>
  </DriverAppFulfilmentFilterCriteria>
)
